export const APPROVE_VALUE =
  '115792089237316195423570985008687907853269984665640564039457584007913129639935'
